export const LANGUAGES = ['it', 'en', 'es', 'fr', 'de'];
export function supportedLanguage(value) {
  const code = String(value || '').trim().toLowerCase().split(/[-_]/)[0];
  return LANGUAGES.includes(code) ? code : null;
}
export const normalizeLanguage = value => supportedLanguage(value) || 'it';
export const normalizePreference = value => String(value || '').toLowerCase() === 'auto' || !value ? 'auto' : normalizeLanguage(value);
export function deviceLanguage(device = typeof navigator === 'undefined' ? null : navigator) {
  const candidates = [...(device?.languages || []), device?.language];
  return candidates.map(supportedLanguage).find(Boolean) || 'it';
}
export const resolveLanguage = value => normalizePreference(value) === 'auto' ? deviceLanguage() : normalizeLanguage(value);
export function storedPreference() {
  try { return normalizePreference(localStorage.getItem('tps:language-preference') || localStorage.getItem('lang') || 'auto'); }
  catch { return 'auto'; }
}
